import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import {
  InputAdornment,
  makeStyles,
  Select,
  Snackbar,
} from '@material-ui/core';

import { DataGrid } from '@material-ui/data-grid';
import { Alert } from '@material-ui/lab';
import { MenuItem } from 'material-ui';
import {
  API_KEY_JOBS,
  APPROVE_USERS_API,
  COLORS,
  PENDING_USERS_API,
  PENDING_USERS_SEARCH_API,
  REJECT_USERS_API,
} from '../../constants';
const AwaitingApproval = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, message: null });
  const [currentPage, setCurrentPage] = useState(1);
  const [nextData, setNextData] = useState(false);

  const columns = [
    { field: 'name', headerName: 'BUILDER NAME', flex: 1 },
    // { field: 'licence', headerName: 'LICENCE' },
    // { field: 'expiry', headerName: 'EXPIRY' },
    { field: 'phoneNumber', headerName: 'PHONE', flex: 1 },
    { field: 'email', headerName: 'EMAIL', flex: 1 },
    {
      field: 'approve',
      headerName: 'APPROVE',
      flex: 1,
      renderCell: param => (
        <Button
          variant="contained"
          type="submit"
          style={style.buttonApprove}
          onClick={async () => {
            setLoading(true);
            const token = localStorage.getItem('accessToken');
            try {
              const response = await axios({
                method: 'put',
                headers: {
                  'Content-Type': 'application/json',
                  'x-api-key': `${API_KEY_JOBS}`,
                  Authorization: `Bearer ${token}`,
                },
                url: `${APPROVE_USERS_API}/${param.row.businessNumber}`,
                validateStatus(status) {
                  return status === 200; // default
                },
              });
              setSnackBar({
                open: true,
                message: 'Builder approved successfully',
              });
              setCurrentPage(1);
              setSearchResults([]);
              fetchData(currentPage);

              return response.data;
            } catch (err) {
              throw err;
            }
          }}
        >
          Approve
        </Button>
      ),
    },
    {
      field: 'reject',
      headerName: 'REJECT',
      flex: 1,
      renderCell: param => (
        <Button
          variant="contained"
          type="submit"
          style={style.buttonRej}
          onClick={async () => {
            setLoading(true);
            const token = localStorage.getItem('accessToken');
            try {
              const response = await axios({
                method: 'put',
                data: {
                  adminEmail: localStorage.getItem('username'),
                },
                headers: {
                  'Content-Type': 'application/json',
                  'x-api-key': `${API_KEY_JOBS}`,
                  Authorization: `Bearer ${token}`,
                },
                url: `${REJECT_USERS_API}/${param.row.businessNumber}`,
                validateStatus(status) {
                  return status === 200; // default
                },
              });
              setSnackBar({
                open: true,
                message: 'Builder rejected successfully',
              });

              setCurrentPage(1);
              setSearchResults([]);
              fetchData(currentPage);

              return response.data;
            } catch (err) {
              throw err;
            }
          }}
        >
          Reject
        </Button>
      ),
    },
  ];
  const fetchData = async page => {
    setSearchInput('');
    setLoading(true);
    const users = await pendingApi(page);
    setPendingUsers(data => [...data, ...users.businesses]);
    setLoading(false);
    const nextSetData = await pendingApi(page + 1);
    setNextData(nextSetData.businesses.length > 0);
  };
  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);
  const style = {
    heading: {
      textAlign: 'center',
      fontSize: '2rem',
      paddingTop: '2rem',
    },
    searchBox: {
      marginBottom: '2rem',
    },
    tableContainer: {
      backgroundColor: COLORS.WHITE,
      margin: '2rem',
      padding: '1rem',
    },
    inputDiv: {
      marginRight: 'auto',
      marginLeft: 'auto',
      marginBottom: '20px',
      paddingBottom: '20px',
      borderRadius: '5px',
      backgroundColor: COLORS.GREY,
    },
    inputForm: {
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
    button: {
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
      marginLeft: '10px',
    },
    buttonRej: {
      width: '90%',
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREY_DARKER,
    },
    buttonApprove: {
      width: '90%',
      fontSize: '1.1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
    },
    buttonInv: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.GREEN,
      backgroundColor: COLORS.WHITE,
    },
    loading: {
      textAlign: 'center',
      marginRight: 'auto',
      marginLeft: 'auto',
    },
    BuilderResults: {
      width: '60%',
      margin: '2rem auto',
    },
    loadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 200,
    },
    loadMoreButtonContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
  const useStyles = makeStyles(theme => ({
    root: {
      border: 0,
      color:
        theme.palette.type === 'light'
          ? 'rgba(0,0,0,.85)'
          : 'rgba(255,255,255,0.85)',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      WebkitFontSmoothing: 'auto',
      letterSpacing: 'normal',
      '& .MuiDataGrid-columnsContainer': {
        backgroundColor: COLORS.GREY,
      },
      '& .MuiDataGrid-iconSeparator': {
        display: 'none',
      },
      '& .MuiDataGrid-colCell, .MuiDataGrid-cell': {
        borderRight: `0px'
        }`,
      },
      '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `2px solid ${
          theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
        }`,
      },
      '& .MuiDataGrid-cell': {
        color:
          theme.palette.type === 'light'
            ? 'rgba(0,0,0,.85)'
            : 'rgba(255,255,255,0.65)',
      },
      '& .MuiPaginationItem-root': {
        borderRadius: 0,
      },
    },
  }));
  const pendingApi = async page => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${PENDING_USERS_API}/${page}`,
        validateStatus(status) {
          return status === 200; // default
        },
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  };
  const [searchLoading, setSearchLoading] = useState(false);
  console.log({ searchLoading, loading });
  const pendingSearchApi = async text => {
    setSearchLoading(true);
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        data: { searchString: text },
        url: `${PENDING_USERS_SEARCH_API}`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      setSearchLoading(false);
      return response.data;
    } catch (err) {
      setSearchLoading(false);
      throw err;
    }
  };
  const [searchInput, setSearchInput] = useState('');
  const handleSubmit = async e => {
    e.preventDefault();
    setPendingUsers([]);
    setNextData(false);
    // const searchQuery = e.target[0].value;

    if (searchInput) {
      const pendingSearchResults = await pendingSearchApi(searchInput);
      setSearchResults(pendingSearchResults.businesses);
    } else {
      setSearchResults(pendingUsers);
    }
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar({ open: false });
  };
  const classes = useStyles();

  const [activityStatus, setActivityStatus] = useState('All');

  const [filteredBuilders, setFilteredBuilders] = useState([]);
  // const filteredBuilders = searchResults.filter((builder) => {
  //   if (activityStatus === 'All') {
  //     return builder;
  //   }
  //   return builder.builderExpiryChanged && builder.builderExpiryChanged === 1;
  // });
  useEffect(() => {
    if (searchResults.length > 0) {
      setFilteredBuilders(
        searchResults.filter(builder => {
          if (activityStatus === 'All') {
            return builder;
          }
          return (
            builder.builderExpiryChanged && builder.builderExpiryChanged === 1
          );
        }),
      );
    } else if (pendingUsers.length > 0) {
      setFilteredBuilders(
        pendingUsers.filter(builder => {
          if (activityStatus === 'All') {
            return builder;
          }
          return (
            builder.builderExpiryChanged && builder.builderExpiryChanged === 1
          );
        }),
      );
    } else {
      setFilteredBuilders([]);
    }
  }, [searchResults, pendingUsers, activityStatus]);

  return (
    <div style={style.inputDiv}>
      <div style={style.heading}>BUILDERS AWAITING APPROVAL</div>
      <div style={style.tableContainer}>
        <form onSubmit={handleSubmit} style={style.inputForm}>
          <TextField
            style={style.searchBox}
            id="standard-full-width"
            label="Search builder by email or name"
            fullWidth
            margin="normal"
            variant="outlined"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        style={style.button}
                        type="submit"
                      >
                        Search
                      </Button>
                      {(searchResults.length > 0 || searchInput) && (
                        <Button
                          variant="contained"
                          style={style.button}
                          onClick={() => {
                            setSearchInput('');
                            setCurrentPage(1);
                            if (searchResults.length > 0) {
                              fetchData(currentPage);
                            }
                            setSearchResults([]);
                          }}
                          // type="submit"
                        >
                          Clear
                        </Button>
                      )}
                    </>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </form>

        {loading || searchLoading ? (
          <div style={style.loadingWrapper}>
            <CircularProgress size={40} />
          </div>
        ) : (
          <>
            <div
              style={{
                width: '100%',
                margin: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                marginLeft: 'auto',
              }}
            >
              <div style={{ marginRight: '15px' }}>Filters : </div>
              <Select
                value={activityStatus}
                labelId="activity-status"
                onChange={e => setActivityStatus(e.target.value)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="builder-expiry-update">
                  Builder expiry updated
                </MenuItem>
              </Select>
            </div>
            <DataGrid
              className={classes.root}
              rows={filteredBuilders}
              columns={columns}
              // pageSize={10}
              disableColumnMenu
              disableColumnSelector
              density="comfortable"
              disableSelectionOnClick
              autoHeight
              hideFooterPagination
            />
            {searchResults.length > 0
              ? ''
              : nextData && (
                  <div style={style.loadMoreButtonContainer}>
                    <Button
                      styles={style.button}
                      variant="contained"
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Load More
                    </Button>
                  </div>
                )}
          </>
        )}

        {/* <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>BUILDER NAME</TableCell>
              <TableCell>LICENCE</TableCell>
              <TableCell>EXPIRY</TableCell>
              <TableCell>PHONE</TableCell>
              <TableCell>EMAIL</TableCell>
              <TableCell align="center">APPROVE</TableCell>
              <TableCell align="center">REJECT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody displayRowCheckbox={false}>
            {pendingUsers.map(row => (
              <TableRow>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row['custom:buildingLicNo']}</TableCell>
                <TableCell>{row['custom:buildingLicExp']}</TableCell>
                <TableCell>{row['custom:personalPhone']}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    type="submit"
                    style={style.buttonApprove}
                  >
                    Approve
                  </Button>
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    type="submit"
                    style={style.buttonRej}
                  >
                    Reject
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        count={5}
        style={style.heading}
        align="center"
        alignItems="center"
        justify="center"
      /> */}
      </div>
      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackBar.open}
        onClose={handleClose}
      >
        <Alert severity="success" onClose={handleClose}>
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const propTypes = {};

AwaitingApproval.propTypes = propTypes;

export default AwaitingApproval;
